import { useTranslation } from 'react-i18next'

import { Widget } from '../../../../Widget'

import { RentalPortalListingPhotoMosaic } from './RentalPortalListingPhotoMosaic'
import { RentalPortalListingProfileDescriptionWidget } from './RentalPortalListingProfileDescriptionWidget'
import { QA_NAME_LISTING_PROFILE_PHOTOS_WIDGET } from './RentalPortalListingProfileExpose.constants'
import { RentalPortalListingProfileKeyFactsWidget } from './RentalPortalListingProfileKeyFactsWidget'
import { RentalPortalListingProfilePhotosWidgetTitle } from './RentalPortalListingProfilePhotosWidgetTitle'

import * as styles from './RentalPortalListingProfileExpose.module.css'

function RentalPortalListingProfileExpose() {
  const { t } = useTranslation()

  return (
    <div className={styles.RentalPortalListingProfileExpose}>
      <Widget
        headerProps={{
          contentProps: {
            actionsProps: { EditButton: null },
            titleProps: {
              Component: RentalPortalListingProfilePhotosWidgetTitle,
            },
          },
        }}
        qaName={QA_NAME_LISTING_PROFILE_PHOTOS_WIDGET}
        title={t('RentalPortal.ListingProfilePhotosTitleKey')}
      >
        <RentalPortalListingPhotoMosaic />
      </Widget>
      <RentalPortalListingProfileKeyFactsWidget />
      <RentalPortalListingProfileDescriptionWidget />
    </div>
  )
}

export default RentalPortalListingProfileExpose
